// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MoreIconBumbleInline = (props: SVGProps<SVGSVGElement>) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 65 65"
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		{...props}
	>
		<defs>
			<linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="MoreIconBumbleInline_tsx__a">
				<stop stopColor="#C5B84D" offset="0%" />
				<stop stopColor="#FFC62A" offset="100%" />
			</linearGradient>
			<path
				d="M25.417 20.696H4.582a.625.625 0 0 0 0 1.25h20.835a.625.625 0 0 0 0-1.25zM23.128 24.5H6.87a.625.625 0 0 0 0 1.25h16.258a.625.625 0 1 0 0-1.25zm4.216-6.985c0 .345-.28.625-.625.625H3.28a.625.625 0 1 1 0-1.25h4.064c.086-4.148 3.487-7.496 7.655-7.496s7.57 3.348 7.656 7.496h4.063c.345 0 .625.28.625.625zM15 7.409c.345 0 .625-.28.625-.625v-3.16a.625.625 0 0 0-1.25 0v3.16c0 .345.28.625.625.625zm-7.702 2.824a.623.623 0 0 0 .883 0 .625.625 0 0 0 0-.884L5.947 7.115A.625.625 0 1 0 5.063 8l2.235 2.234zm14.52 0a.625.625 0 0 1 0-.884l2.235-2.234a.625.625 0 1 1 .884.884l-2.235 2.234a.623.623 0 0 1-.884 0z"
				id="MoreIconBumbleInline_tsx__b"
			/>
		</defs>
		<g fill="none" fillRule="evenodd">
			<circle fill="url(#MoreIconBumbleInline_tsx__a)" cx={32.5} cy={32.5} r={32.5} />
			<use fill="#FFF" xlinkHref="#MoreIconBumbleInline_tsx__b" transform="translate(18 18)" />
		</g>
	</svg>
);
export default MoreIconBumbleInline;
